import { createPinia } from 'pinia';
import { defineStore } from '@seedkit/app/wrappers';

export default defineStore(() => {
  const pinia = createPinia();
  return pinia;
});
